import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column items-center text-center" }
const _hoisted_2 = { class: "relative-position q-mb-md" }
const _hoisted_3 = { class: "text-h5 text-white q-mb-sm" }
const _hoisted_4 = { class: "text-subtitle2 text-white opacity-80 q-mb-sm" }
const _hoisted_5 = { class: "text-subtitle2 text-white opacity-80 q-mb-lg" }
const _hoisted_6 = {
  key: 0,
  class: "q-mt-md q-mb-lg"
}
const _hoisted_7 = { class: "text-h6 text-white" }
const _hoisted_8 = { class: "text-subtitle2 text-white opacity-90" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderSucess',
  props: {
    startDate: {},
    duration: {}
  },
  setup(__props: any) {

const props = __props

// 🌍 Sprache anhand der URL bestimmen
const path = window.location.pathname
const lang = path.startsWith('/en/') ? 'en' : 'de'

// Dynamische Fehlermeldung
const message1 = computed(() =>
  lang === 'de'
    ? 'Zahlung erfolgreich eingegangen'
    : 'Payment received successfully'
)

const message2 = computed(() =>
  lang === 'de'
    ? 'Dein Termin wurde erfolgreich gebucht'
    : 'Your appointment has been successfully booked'
)

const message3 = computed(() =>
  lang === 'de'
    ? 'und eine Bestätigung wurde an dich versendet.'
    : 'and a confirmation has been sent to you.'
)

const message4 = computed(() =>
  lang === 'de'
    ? '(Die E-Mail könnte in deinem Spam-Ordner gelandet sein)'
    : '(The email may have ended up in your spam folder)'
)
// formatiertes Datum wie "Montag, 10. November 2025"
const formattedDate = computed(() => {
  if (!props.startDate) return ''
  return new Intl.DateTimeFormat('de-DE', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(props.startDate)
})

// Zeitspanne wie "12:30 – 13:30 Uhr"
const timeRange = computed(() => {
  if (!props.startDate || !props.duration) return ''
  const start = props.startDate
  const end = new Date(start.getTime() + props.duration * 60000)
  const fmt = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' })
  return `${fmt.format(start)} – ${fmt.format(end)} Uhr`
})

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "success-card q-pa-xl q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_icon, {
            name: "check_circle",
            color: "positive",
            size: "80px"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pulse" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(message1.value), 1),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(message2.value), 1),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(message3.value), 1)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(message4.value), 1),
        _createVNode(_component_q_separator, {
          dark: "",
          spaced: ""
        }),
        (__props.startDate && __props.duration)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(formattedDate.value), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(timeRange.value), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})